import type { i18n as I18n } from "i18next";
import { OrganizationVocabulary } from "../models/Organization";
import { buildVocabularyVariables } from "./vocabularyVariables";

let activeVocabulary: OrganizationVocabulary | null = null;

const applyVariables = (i18n: I18n): void => {
  if (!i18n.options.interpolation) {
    i18n.options.interpolation = {};
  }
  i18n.options.interpolation.defaultVariables = buildVocabularyVariables(
    activeVocabulary,
    i18n.language
  );
};

/**
 * Keeps i18next's `interpolation.defaultVariables` in step with the UI
 * language, so every `t("key")` resolves `{{member}}` & co. without passing
 * arguments. Call once, right after `i18n.init`; it registers before any
 * component's listener, so the words are swapped before the re-render.
 */
export const bindVocabularyToI18n = (i18n: I18n): void => {
  applyVariables(i18n);
  i18n.on("languageChanged", () => applyVariables(i18n));
};

/**
 * Sets the organization's vocabulary (null = the Default preset) and
 * re-renders every translated component.
 */
export const setActiveVocabulary = (
  i18n: I18n,
  vocabulary: OrganizationVocabulary | null
): void => {
  if (vocabulary === activeVocabulary) return;
  activeVocabulary = vocabulary;
  applyVariables(i18n);
  // react-i18next re-renders its consumers on "languageChanged".
  i18n.emit("languageChanged", i18n.language);
};
